export default __webpack_public_path__ + "static/media/figmaIcon.3ce45014.svg";